import { render } from "./CustomDropdown.vue?vue&type=template&id=6e40e27f&scoped=true"
import script from "./CustomDropdown.vue?vue&type=script&lang=js"
export * from "./CustomDropdown.vue?vue&type=script&lang=js"

import "./CustomDropdown.vue?vue&type=style&index=0&id=6e40e27f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e40e27f"]])

export default __exports__